import React from 'react';
import { Apple, Cherry, Grape } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

export const Hero = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-amber-50 pt-16 overflow-hidden">
      {/* Decorative Fruit Icons */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Top Left */}
        <div className="absolute top-20 left-10 opacity-10 animate-bounce" style={{ animationDelay: '0s', animationDuration: '3s' }}>
          <Apple className="w-24 h-24 text-orange-400" />
        </div>
        <div className="absolute top-40 left-32 opacity-10 animate-bounce" style={{ animationDelay: '1s', animationDuration: '4s' }}>
          <Cherry className="w-20 h-20 text-red-400" />
        </div>
        
        {/* Top Right */}
        <div className="absolute top-32 right-20 opacity-10 animate-bounce" style={{ animationDelay: '0.5s', animationDuration: '3.5s' }}>
          <Grape className="w-20 h-20 text-amber-400" />
        </div>
        <div className="absolute top-64 right-40 opacity-10 animate-bounce" style={{ animationDelay: '1.5s', animationDuration: '4.5s' }}>
          <Apple className="w-16 h-16 text-orange-400" />
        </div>
        
        {/* Bottom Left */}
        <div className="absolute bottom-40 left-20 opacity-10 animate-bounce" style={{ animationDelay: '2s', animationDuration: '3.8s' }}>
          <Grape className="w-24 h-24 text-amber-400" />
        </div>
        <div className="absolute bottom-64 left-44 opacity-10 animate-bounce" style={{ animationDelay: '0.8s', animationDuration: '4.2s' }}>
          <Cherry className="w-18 h-18 text-red-400" />
        </div>
        
        {/* Bottom Right */}
        <div className="absolute bottom-48 right-24 opacity-10 animate-bounce" style={{ animationDelay: '1.2s', animationDuration: '3.3s' }}>
          <Apple className="w-20 h-20 text-orange-400" />
        </div>
        <div className="absolute bottom-72 right-52 opacity-10 animate-bounce" style={{ animationDelay: '2.5s', animationDuration: '4s' }}>
          <Cherry className="w-16 h-16 text-red-400" />
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32 relative z-10">
        <div className="text-center">
          {/* Icon */}
          <div className="flex justify-center mb-8">
            <div className="p-6 bg-black rounded-xl shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_e89f86fd-ccbb-428c-8bc5-5519914e6241/artifacts/77hlnuis_image.png"
                alt={language === 'ar' ? 'شعار شركة الحنادس - استيراد الفواكه الطازجة العراق' : 'AL HANADIS COMPANY Logo - Premium Fresh Fruit Import Iraq'}
                className="h-24 w-auto object-contain"
              />
            </div>
          </div>

          {/* Main heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-800 mb-6 leading-tight">
            {t.companyName}
          </h1>

          {/* Tagline */}
          <p className="text-2xl sm:text-3xl font-semibold text-orange-600 mb-8">
            {t.tagline}
          </p>

          {/* Description */}
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto mb-12 leading-relaxed">
            {t.heroDescription}
          </p>

          {/* CTA Button */}
          <button
            onClick={scrollToContact}
            className="inline-flex items-center px-8 py-4 text-lg font-medium text-white bg-orange-500 hover:bg-orange-600 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
          >
            {t.getInTouch}
          </button>
        </div>
      </div>

      {/* Decorative bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full">
          <path
            fill="#ffffff"
            fillOpacity="1"
            d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
          ></path>
        </svg>
      </div>
    </section>
  );
};
